import { IRound } from 'modules/admin-panel/pages/results/models';

export const getPrevRound = (rounds?: IRound[], roundId?: string) => {
	const currRoundIndex = rounds?.findIndex(
		(round: IRound) => round.surveyRoundId === roundId,
	);

	if (currRoundIndex && rounds && currRoundIndex > 0) {
		return rounds[currRoundIndex - 1];
	}
};
